export default "__VITE_ASSET__AH_1$C4A__"